// Renew active embeds before the API's 15-minute Grafana session expires.
export const GRAFANA_EMBED_QUERY_OPTIONS = {
  staleTime: 0,
  refetchOnMount: "always",
  refetchInterval: 12 * 60 * 1000,
} as const;
